import { render, staticRenderFns } from "./QuitInfo.vue?vue&type=template&id=84a5a900&"
import script from "./QuitInfo.vue?vue&type=script&lang=js&"
export * from "./QuitInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuitInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports